// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c9d348ea] a.nav-link.active {\n  color: #ff7058 !important;\n  border-bottom: 3px solid #ff7058 !important;\n}\n.text-yellow[data-v-c9d348ea] {\n  color: #f8b63c;\n}", ""]);
// Exports
module.exports = exports;
